// const Oss = function (url, catalogue) {
//   const com = `https://store-img.cre-tep.com/frontDeskProject/`;
//   return `${com}${catalogue || "images"}/${url}`;
// };

// minio 地址 http://1.94.254.79:9099
const Oss = function (url) {
  return `https://www.xctpt.com/rimp/front/${url}`;
};
export default {
  install(Vue) {
    Object.assign(Vue.prototype, {
      $oss: Oss,
    });
  },
};
